<script>
    import { formatNumber } from '../utils';

    export let number;
    export let liters;

    const charClassOverrideMap = new Map([
        ['_', 'empty'],
        [' ', 'space'],
        [',', 'comma'],
        ['0', 'zero'],
        ['1', 'one'],
        ['2', 'two'],
        ['3', 'three'],
        ['4', 'four'],
        ['5', 'five'],
        ['6', 'six'],
        ['7', 'seven'],
        ['8', 'eight'],
        ['9', 'nine'],
    ]);

    let numberChars = ['_', '_', ',', '_', '_'];
    function setNumberChars(newNumber, newLiters) {
        const num = newNumber * newLiters;

        if (typeof num === 'number' && !Number.isNaN(num)) {
            const numberString = formatNumber(num);

            const wholeNumberLength = numberString.replace(/,\d+$/, '').length;
            if (wholeNumberLength === 1) {
                numberChars = ['_', ...numberString.split('')];
            } else if (wholeNumberLength === 3) {
                numberChars = ['_', ' ', ...numberString.split('')];
            } else {
                numberChars = numberString.split('');
            }
        }
    }

    $: setNumberChars(number, liters);
</script>

<style>
    div {
        margin-top: var(--margin);
    }

    .preload {
        opacity: 0.01;
        width: 0px;
        height: 0px;
        margin: 0;
        padding: 0;
        background-position: -9999px -9999px;
    }

    .number {
        display: inline-block;
        height: 61px;
        width: 33px;
        margin-right: 8px;
        object-fit: cover;
        background-repeat: no-repeat;
    }

    .unit {
        font-size: 18px;
    }

    .empty {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/_.svg);
    }

    .comma {
        width: 4px;
        height: 4px;
        background: var(--color-light);
    }

    .space {
        width: 4px;
        height: 0px;
    }

    .zero {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/0.svg);
    }

    .one {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/1.svg);
    }

    .two {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/2.svg);
    }

    .three {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/3.svg);
    }

    .four {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/4.svg);
    }

    .five {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/5.svg);
    }

    .six {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/6.svg);
    }

    .seven {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/7.svg);
    }

    .eight {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/8.svg);
    }

    .nine {
        background-image: url(https://e24.no/vgc/spesial/2022/03/bensinkalkulator/static/v2/9.svg);
    }

    @media (min-width: 600px) {
        div {
            margin-top: var(--margin-large);
        }

        .number {
            height: 64px;
            width: 35px;
        }

        .space,
        .comma {
            width: 5px;
            height: 5px;
        }
    }
</style>

<div>
    {#each Array.from(charClassOverrideMap.values()) as numberClassName}
        <div class={`preload ${numberClassName}`}></div>
    {/each}
    {#each numberChars as char}
        <span class={`number ${charClassOverrideMap.get(char) ?? char}`} />
    {/each}
    {#if liters > 1}
        <span class="unit">kr/{liters}L</span>
    {:else}
        <span class="unit">kr/L</span>
    {/if}
</div>
